import { cn } from '@/lib/utils';
import avatarRunner from '@/assets/avatar-runner.png';

interface ProfileAvatarProps {
  name?: string;
  email?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizeClasses = {
  sm: 'h-8 w-8',
  md: 'h-12 w-12',
  lg: 'h-16 w-16',
  xl: 'h-24 w-24',
};

const ringClasses = {
  sm: 'p-[2px]',
  md: 'p-[2px]',
  lg: 'p-[3px]',
  xl: 'p-[3px]',
};

export function ProfileAvatar({ size = 'lg', className }: ProfileAvatarProps) {
  return (
    <div
      className={cn(
        'rounded-full shrink-0',
        'bg-gradient-to-br from-[#00FFC8] via-[#00B4D8] to-[#00FFC8]',
        'shadow-[0_0_20px_rgba(0,255,200,0.3)]',
        ringClasses[size],
        className
      )}
    >
      <div
        className={cn(
          'rounded-full flex items-center justify-center overflow-hidden',
          'bg-[#0B0E14]',
          sizeClasses[size],
        )}
      >
        <img
          src={avatarRunner}
          alt="Athlete avatar"
          className="w-full h-full object-cover scale-[1.4]"
        />
      </div>
    </div>
  );
}
